import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UIButton = _resolveComponent("UIButton")!
  const _component_SharedWindow = _resolveComponent("SharedWindow")!

  return (_openBlock(), _createBlock(_component_SharedWindow, {
    class: _normalizeClass(_ctx.b()),
    title: "Подтверждение заявки",
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('content'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('list'))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Со счета")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('item-label'))
            }, _toDisplayString(_ctx.displayedCurrencyFrom.name.toUpperCase()), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item', { to: true }))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('item-group'))
            }, [
              _createElementVNode("h4", {
                class: _normalizeClass(_ctx.b('item-title'))
              }, _toDisplayString(_ctx.$t("На счет")), 3),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.b('item-label'))
              }, _toDisplayString(_ctx.displayedCurrencyTo.currency?.name.toUpperCase() ||
                _ctx.displayedCurrencyTo.name), 3)
            ], 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Текущий курс")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('item-label'))
            }, _toDisplayString(_ctx.displayedCourse) + " " + _toDisplayString(_ctx.displayedCurrencyTo.name.toUpperCase()), 3)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item', { operation: true }))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Операция")), 3),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.b('item-operation'))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.b('item-icon')),
                innerHTML: _ctx.displayedSvg.chevron
              }, null, 10, _hoisted_1),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.b('item-operations'))
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.b('item-label'))
                }, _toDisplayString(_ctx.displayedAmountFrom) + " " + _toDisplayString(_ctx.displayedCurrencyFrom.name.toUpperCase()), 3),
                _createElementVNode("p", {
                  class: _normalizeClass(_ctx.b('item-label'))
                }, " ~ " + _toDisplayString(_ctx.displayedAmountTo) + " " + _toDisplayString(_ctx.displayedCurrencyTo.name.toUpperCase()), 3)
              ], 2)
            ], 2)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.b('item'))
          }, [
            _createElementVNode("h4", {
              class: _normalizeClass(_ctx.b('item-title'))
            }, _toDisplayString(_ctx.$t("Комиссия")), 3),
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('item-label'))
            }, _toDisplayString(_ctx.displayedCommissions), 3)
          ], 2)
        ], 2),
        _createVNode(_component_UIButton, {
          label: 
          _ctx.displayedApplicationStoreRequest.currency_type_to === 'crypto' &&
          _ctx.displayedApplicationStoreRequest.currency_type_from === 'crypto'
            ? 'Обмен'
            : 'Создать заявку'
        ,
          view: "main",
          onClick: _ctx.handleCreate
        }, null, 8, ["label", "onClick"])
      ], 2)
    ]),
    _: 1
  }, 8, ["class", "onClose"]))
}